// import React from 'react';
// import { Card, CardContent, Typography, Box, useTheme } from '@mui/material';

// import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';

// // function stringToColor(string) {
// //   if (!string) {
// //     return '#000000';
// //   }
// //   let hash = 0;
// //   let i;
// //   for (i = 0; i < string.length; i += 1) {
// //     hash = string.charCodeAt(i) + ((hash << 5) - hash);
// //   }
// //   let color = '#';
// //   for (i = 0; i < 3; i += 1) {
// //     const value = (hash >> (i * 8)) & 0xff;
// //     color += `00${value.toString(16)}`.slice(-2);
// //   }
// //   return color;
// // }

// const PerformerOfTheMonth = ({ staffMonthlyPerformance, selectedMonth }) => {
//   const theme = useTheme();
//   const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

//   if (!staffMonthlyPerformance || staffMonthlyPerformance.length === 0) {
//     return null; // Or a placeholder if no staff data
//   }

//   let topPerformer = null;
//   let maxWorkAmount = -1;
//   let periodLabel = '';

//   if (selectedMonth === 'all') {
//     periodLabel = 'Year';
//     staffMonthlyPerformance.forEach(staff => {
//       if (staff.totalYearWork > maxWorkAmount) {
//         maxWorkAmount = staff.totalYearWork;
//         topPerformer = staff;
//       }
//     });
//   } else {
//     periodLabel = `for ${monthNames[selectedMonth - 1]}`;
//     staffMonthlyPerformance.forEach(staff => {
//       const monthData = staff.monthly.find(m => m.month === selectedMonth);
//       if (monthData && monthData.totalWorkAmount > maxWorkAmount) {
//         maxWorkAmount = monthData.totalWorkAmount;
//         topPerformer = staff;
//       }
//     });
//   }

//   if (!topPerformer || maxWorkAmount <= 0) {
//     return (
//       <Card sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
//         <CardContent>
//           <Typography variant="h6" textAlign="center">No top performer found for the selected period.</Typography>
//         </CardContent>
//       </Card>
//     );
//   }

//   return (
//     <Card sx={{ backgroundColor: theme.palette.background.default, p: 2, borderRadius: 3, boxShadow: 3 }}>
//       <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>
//         <EmojiEventsOutlinedIcon sx={{ fontSize: '3.5rem', color: theme.palette.warning.main }} />
//         <Box textAlign="left">
//           <Typography variant="h6" fontWeight="bold">{topPerformer.staffName}</Typography>
//           <Typography variant="subtitle2" color="text.secondary">Top Performer {periodLabel}</Typography>
//         </Box>
//         <Box textAlign="right" flexGrow={1}>
//             <Typography variant="h5" fontWeight="bold">
//               ₹{maxWorkAmount.toLocaleString('en-IN', {
//                 minimumFractionDigits: 0,
//                 maximumFractionDigits: 0,
//               })}
//             </Typography>
//             <Typography variant="caption" color="text.secondary">
//               Total Work
//             </Typography>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// export default PerformerOfTheMonth;
// import React from 'react';
// import { Card, CardContent, Typography, Box, useTheme } from '@mui/material';

// import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';

// // function stringToColor(string) {
// //   if (!string) {
// //     return '#000000';
// //   }
// //   let hash = 0;
// //   let i;
// //   for (i = 0; i < string.length; i += 1) {
// //     hash = string.charCodeAt(i) + ((hash << 5) - hash);
// //   }
// //   let color = '#';
// //   for (i = 0; i < 3; i += 1) {
// //     const value = (hash >> (i * 8)) & 0xff;
// //     color += `00${value.toString(16)}`.slice(-2);
// //   }
// //   return color;
// // }

// const PerformerOfTheMonth = ({ staffMonthlyPerformance, selectedMonth }) => {
//   const theme = useTheme();
//   const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

//   if (!staffMonthlyPerformance || staffMonthlyPerformance.length === 0) {
//     return null; // Or a placeholder if no staff data
//   }

//   let topPerformer = null;
//   let maxWorkAmount = -1;
//   let periodLabel = '';

//   if (selectedMonth === 'all') {
//     periodLabel = 'Year';
//     staffMonthlyPerformance.forEach(staff => {
//       if (staff.totalYearWork > maxWorkAmount) {
//         maxWorkAmount = staff.totalYearWork;
//         topPerformer = staff;
//       }
//     });
//   } else {
//     periodLabel = `for ${monthNames[selectedMonth - 1]}`;
//     staffMonthlyPerformance.forEach(staff => {
//       const monthData = staff.monthly.find(m => m.month === selectedMonth);
//       if (monthData && monthData.totalWorkAmount > maxWorkAmount) {
//         maxWorkAmount = monthData.totalWorkAmount;
//         topPerformer = staff;
//       }
//     });
//   }

//   if (!topPerformer || maxWorkAmount <= 0) {
//     return (
//       <Card sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
//         <CardContent>
//           <Typography variant="h6" textAlign="center">No top performer found for the selected period.</Typography>
//         </CardContent>
//       </Card>
//     );
//   }

//   return (
//     <Card sx={{ backgroundColor: theme.palette.background.default, p: 2, borderRadius: 3, boxShadow: 3 }}>
//       <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>
//         <EmojiEventsOutlinedIcon sx={{ fontSize: '3.5rem', color: theme.palette.warning.main }} />
//         <Box textAlign="left">
//           <Typography variant="h6" fontWeight="bold">{topPerformer.staffName}</Typography>
//           <Typography variant="subtitle2" color="text.secondary">Top Performer {periodLabel}</Typography>
//         </Box>
//         <Box textAlign="right" flexGrow={1}>
//             <Typography variant="h5" fontWeight="bold">
//               ₹{maxWorkAmount.toLocaleString('en-IN', {
//                 minimumFractionDigits: 0,
//                 maximumFractionDigits: 0,
//               })}
//             </Typography>
//             <Typography variant="caption" color="text.secondary">
//               Total Work
//             </Typography>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// export default PerformerOfTheMonth;
import React from 'react';
import { Card, CardContent, Typography, Box, useTheme, Tooltip, Stack, Chip } from '@mui/material';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const PerformerOfTheMonth = ({ staffMonthlyPerformance, selectedMonth }) => {
  const theme = useTheme();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  if (!staffMonthlyPerformance || staffMonthlyPerformance.length === 0) {
    return null;
  }

  let topPerformer = null;
  let maxWorkAmount = -1;
  let periodLabel = '';
  let topMonthData = null;

  if (selectedMonth === 'all') {
    periodLabel = 'Year';
    staffMonthlyPerformance.forEach((staff) => {
      if (staff.totalYearWork > maxWorkAmount) {
        maxWorkAmount = staff.totalYearWork;
        topPerformer = staff;
      }
    });
  } else {
    periodLabel = `for ${monthNames[selectedMonth - 1]}`;
    staffMonthlyPerformance.forEach((staff) => {
      const monthData = staff.monthly.find((m) => m.month === selectedMonth);
      if (monthData && monthData.totalWorkAmount > maxWorkAmount) {
        maxWorkAmount = monthData.totalWorkAmount;
        topPerformer = staff;
        topMonthData = monthData;
      }
    });
  }

  if (!topPerformer || maxWorkAmount <= 0) {
    return (
      <Card sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
        <CardContent>
          <Typography variant="h6" textAlign="center">
            No top performer found for the selected period.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  const fmt = (n) =>
    `₹${(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

  return (
    <Card sx={{ backgroundColor: theme.palette.background.default, p: 2, borderRadius: 3, boxShadow: 3 }}>
      <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 3, flexWrap: 'wrap' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <EmojiEventsOutlinedIcon sx={{ fontSize: '3.5rem', color: theme.palette.warning.main }} />
          <Box textAlign="left">
            <Typography variant="h6" fontWeight="bold">
              {topPerformer.staffName}
            </Typography>
            <Typography variant="subtitle2" color="text.secondary">
              Top Performer {periodLabel}
            </Typography>
          </Box>
        </Box>

        <Box textAlign="right">
          <Tooltip
            arrow
            title={
              selectedMonth === 'all'
                ? 'Total work amount for the whole year (service + product across all months)'
                : "This month's Total Work = Service Amount (billed this month) + Product Amount (billed this month). Due payments cleared or bills created late are shown separately below."
            }
          >
            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, cursor: 'help' }}>
              <Typography variant="h5" fontWeight="bold">
                {fmt(maxWorkAmount)}
              </Typography>
              <InfoOutlinedIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
            </Box>
          </Tooltip>
          <Typography variant="caption" color="text.secondary" display="block">
            Total Work
          </Typography>
        </Box>
      </CardContent>

      {selectedMonth !== 'all' && topMonthData && (
        <Box sx={{ px: 2, pb: 2 }}>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Chip
              size="small"
              label={`Service: ${fmt(topMonthData.totalServiceAmount)}`}
              sx={{ bgcolor: theme.palette.success.light, color: theme.palette.success.dark, fontWeight: 600 }}
            />
            <Chip
              size="small"
              label={`Product: ${fmt(topMonthData.totalProductAmount)}`}
              sx={{ bgcolor: theme.palette.warning.light, color: theme.palette.warning.dark, fontWeight: 600 }}
            />
            {(topMonthData.duePaymentServiceAmount > 0 || topMonthData.duePaymentProductAmount > 0) && (
              <Tooltip
                arrow
                title="Amount collected THIS month for old bills' pending dues (the original bill was billed in an earlier month)"
              >
                <Chip
                  size="small"
                  icon={<InfoOutlinedIcon sx={{ fontSize: '0.9rem !important' }} />}
                  label={`Due Cleared: ${fmt(
                    (topMonthData.duePaymentServiceAmount || 0) + (topMonthData.duePaymentProductAmount || 0)
                  )}`}
                  sx={{ bgcolor: theme.palette.info.light, color: theme.palette.info.dark, fontWeight: 600 }}
                />
              </Tooltip>
            )}
            {(topMonthData.createdThisMonthBilledPrevMonthServiceAmount > 0 ||
              topMonthData.createdThisMonthBilledPrevMonthProductAmount > 0) && (
              <Tooltip
                arrow
                title="Bills that were CREATED this month in the system, but backdated to an earlier billing date"
              >
                <Chip
                  size="small"
                  icon={<InfoOutlinedIcon sx={{ fontSize: '0.9rem !important' }} />}
                  label={`Backdated Entries: ${fmt(
                    (topMonthData.createdThisMonthBilledPrevMonthServiceAmount || 0) +
                      (topMonthData.createdThisMonthBilledPrevMonthProductAmount || 0)
                  )}`}
                  sx={{ bgcolor: theme.palette.secondary.light, color: theme.palette.secondary.dark, fontWeight: 600 }}
                />
              </Tooltip>
            )}
          </Stack>
        </Box>
      )}
    </Card>
  );
};

export default PerformerOfTheMonth;